var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoCalculVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.003,
    height: 51.528,
    viewBox: "0 0 54.003 51.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 54.003,
    height: 51.528,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Picto_calcul_volume",
    "data-name": "Picto calcul volume",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_88",
    "data-name": "Trac\\xE9 88",
    d: "M54,46.322a9.612,9.612,0,0,1-9.612,9.612L.115,56.2c-.167,0-.1-.406-.1-.573a.3.3,0,0,1,.3-.3H46.293a7.1,7.1,0,0,0,7.1-7.1V16.2a.3.3,0,1,1,.606,0Z",
    transform: "translate(0 -4.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_89",
    "data-name": "Trac\\xE9 89",
    d: "M39.041,34.368c-2.344,0-4.112-1.431-5.728-2.739-2.13-1.724-3.968-3.212-6.761-1.689-1.218.664-2.285,1.316-3.227,1.89-4.222,2.577-6.547,3.994-11.667-.1C5.878,27.106.751,32.1.536,32.314a.3.3,0,0,1-.429-.428c.056-.057,5.722-5.595,11.93-.63,4.786,3.829,6.725,2.648,10.972.056.947-.578,2.022-1.233,3.253-1.9,3.146-1.717,5.326.044,7.433,1.75,2.271,1.84,4.622,3.742,8.441,1.758a7.6,7.6,0,0,0,2.2-1.791c1.43-1.645,5.053-3.469,9.555.133a.3.3,0,0,1-.379.474c-4.143-3.315-7.43-1.691-8.719-.209a8.188,8.188,0,0,1-2.38,1.931,7.273,7.273,0,0,1-3.375.916",
    transform: "translate(-0.005 -8.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_90",
    "data-name": "Trac\\xE9 90",
    d: "M39.041,42.1c-2.344,0-4.112-1.431-5.728-2.739-2.13-1.724-3.968-3.212-6.761-1.689-1.218.664-2.285,1.316-3.227,1.89-4.222,2.576-6.547,4-11.667-.1C5.878,34.84.751,39.834.536,40.049a.3.3,0,1,1-.429-.428c.056-.057,5.722-5.595,11.93-.63,4.786,3.83,6.725,2.648,10.972.056.947-.578,2.022-1.233,3.253-1.9,3.146-1.717,5.326.044,7.433,1.75,2.271,1.839,4.622,3.742,8.441,1.758a7.6,7.6,0,0,0,2.2-1.791c1.43-1.645,5.053-3.469,9.555.133a.3.3,0,0,1-.379.474c-4.143-3.315-7.43-1.691-8.719-.209a8.188,8.188,0,0,1-2.38,1.931,7.273,7.273,0,0,1-3.375.916",
    transform: "translate(-0.005 -10.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_91",
    "data-name": "Trac\\xE9 91",
    d: "M36.718,21.4a.3.3,0,0,1-.3-.3V6.863c0-.033-.113-4.442,3.5-5.913a4.857,4.857,0,0,1,6.057,1.9A9.937,9.937,0,0,1,47.12,6.834a.3.3,0,0,1-.272.332.3.3,0,0,1-.332-.272A9.339,9.339,0,0,0,45.45,3.151a4.25,4.25,0,0,0-5.3-1.64c-3.22,1.31-3.127,5.3-3.125,5.342v14.24a.3.3,0,0,1-.3.3",
    transform: "translate(-10.711 -0.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_92",
    "data-name": "Trac\\xE9 92",
    d: "M57.9,25.477a.3.3,0,0,1-.3-.3V7.673c-.006-.212-.112-5.4,3.481-7.2A4.305,4.305,0,0,1,64.434.232a4.789,4.789,0,0,1,2.734,2.559A14.274,14.274,0,0,1,68.3,7.648a.3.3,0,1,1-.6.049A13.686,13.686,0,0,0,66.62,3.049,4.193,4.193,0,0,0,64.236.805a3.7,3.7,0,0,0-2.886.212C58.1,2.643,58.2,7.614,58.2,7.664v17.51a.3.3,0,0,1-.3.3",
    transform: "translate(-16.941 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_93",
    "data-name": "Trac\\xE9 93",
    d: "M51.708,17.363H36.847a.3.3,0,1,1,0-.606H51.708a.3.3,0,1,1,0,.606",
    transform: "translate(-10.749 -4.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_94",
    "data-name": "Trac\\xE9 94",
    d: "M51.411,25.912H36.866a.3.3,0,1,1,0-.606H51.411a.3.3,0,1,1,0,.606",
    transform: "translate(-10.754 -7.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_95",
    "data-name": "Trac\\xE9 95",
    d: "M.144,40.094V62.021H49.177a4.853,4.853,0,0,0,4.853-4.868l-.052-17.692s-4.423-4.378-9.968.052-11.388-.735-11.388-.735-2.5-5.487-10.469.919-12.308-8.313-22.008.4",
    transform: "translate(-0.042 -10.763)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoCalculVolume);
export default __webpack_public_path__ + "static/media/picto_calcul_volume.6fc6169d99639349e8ca495dba7fb3e4.svg";
export { ForwardRef as ReactComponent };